import styles from './Search.less';

import React, { Component, PropTypes } from 'react';
import TransitionGroup from 'react/lib/ReactCSSTransitionGroup';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import classnames from 'classnames';

import { updateCriteria, getCounts } from 'store/search/search';
import SearchBar from 'SearchBar/SearchBar';
import RefineBar from 'RefineBar/RefineBar';
import ContentSlider from 'ContentSlider/ContentSlider';

const hooks = {
  fetch({ dispatch, path, query }) {
    return dispatch(updateCriteria({ path, query }));
  },
  defer({ dispatch, locale, path, query }) {
    return dispatch(getCounts({ locale, path, query }));
  }
};

function mapStateToProps({ location }) {
  return {
    isHomepage: location.isHomepage
  };
}

@provideHooks(hooks)
@connect(mapStateToProps)
export default class Search extends Component {

  static propTypes = {
    isHomepage: PropTypes.bool.isRequired,
    children: PropTypes.node
  };

  render() {
    const { isHomepage, children } = this.props;
    const filterClasses = classnames({
      [styles.filters]: true,
      [styles.filters_isExpanded]: isHomepage
    });

    return (
      <div className={styles.root}>
        <div className={filterClasses}>
          <SearchBar collapsed={!isHomepage} />
          <RefineBar expanded={!isHomepage} />
        </div>

        <ContentSlider trigger={['searchbar', 'refinebar']}>
          <TransitionGroup
            transitionName={{ enter: styles.transitionEnter, enterActive: styles.transitionEnterActive }}
            transitionEnterTimeout={600}
            transitionLeave={false}>
            { children }
          </TransitionGroup>
        </ContentSlider>
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/Search.js
 **/